import React from 'react';
import Disclosure from "../../../components/Purchases/Disclosure";
import PageBreak from "./PageBreak";

import "./PrintReport.css"
import Page from "./Page";
import ArtificialInflationGraphContainer
    from "../../../common/components/ArtificialInflationGraph/ArtificialInflationGraphContainer";
import PrelimDamagesContainer from "../PrelimDamages/PrelimDamagesContainer";
import DollarValueInflationContainer from "../DollarValueInflation/DollarValueInflationContainer";
import ClassPeriodTradingStatContainer from "../ClassPeriodTradingStat/ClassPeriodTradingStatContainer";
import MarketCapLossesContainer from "../MarketCapLosses/MarketCapLossesContainer";
import StatAnalysisContainer from "../StatAnalysis/StatAnalysisContainer";

const PrintReport = (props) => {
    let header = null;
    var type = sessionStorage.getItem('Type')
    switch (type) {
        case CASE_REPORT_TYPE:
            header = <React.Fragment>
                <div className={"print-document-header-case-info-company-name"}>{props.currentFillingName}</div>
                <div className={"print-document-header-case-info-docker-number"}>{props.docketNumber}</div> 
                <br />
                <div className={"print-document-header-case-info-date"}>{props.purchaseTime}</div>
            </React.Fragment>;
            break;
        case COMMISSION_REPORT_TYPE:
            header = <React.Fragment>
                <div className={"print-document-header-case-info-company-name"}>{props.currentFillingName}</div>
            </React.Fragment>;
            break;
        case DANDO_REPORT_TYPE:
            header = <React.Fragment>
                <div className={"print-document-header-case-info-company-name"}>{props.companyName}</div>
            </React.Fragment>;
            break;
        default:
            break;
    }


    return (
        <div className={"printed"}>
            <div className={"print-document"}>
                <Page>
                    <Disclosure/>
                </Page>
                <PageBreak/>
                <div className={"print-document-header"}>
                    <div><img style={{height: '75px'}} src={"/SAR-logo-report.jpg"} alt={'SAR-logo'}/></div>
                    <div className={"print-document-header-case-info"}>
                        {header}
                    </div>
                </div>
                <Page>
                    {props.correctiveEvents}
                    <ClassPeriodTradingStatContainer
                        classPeriodTradingStats={props.classPeriodTradingStats}/>
                    <MarketCapLossesContainer
                        marketCapitalizationLosses={props.marketCapitalizationLosses}/>
                    <StatAnalysisContainer statResidualReturns={props.statResidualReturns}/>
                </Page>
                <PageBreak/>
                <Page>
                    <DollarValueInflationContainer
                        dollarValueInflations={props.dollarValueInflations}/>
                    <PrelimDamagesContainer aggregateDamages={props.aggregateDamages} aggregateDamagesNOPSLRA={props.aggregateDamagesNOPSLRA} classFloatAverages={props.classFloatAverages} />
                </Page>
                <Page>
                    <ArtificialInflationGraphContainer 
                    stockPrices={props.stockPrices}
                    aggregateDamagesNOPSLRA={props.aggregateDamagesNOPSLRA}/>
                </Page>
            </div>
        </div>
    )
};

export default PrintReport;


export const CASE_REPORT_TYPE = 'CASE';
export const COMMISSION_REPORT_TYPE = 'COMMISSION';
export const DANDO_REPORT_TYPE = 'DANDO';




// WEBPACK FOOTER //
// ./src/common/components/PrintReport/PrintReport.js